import React, { useState, useEffect } from "react";
import styles from "./ManagePermissions.module.scss";
import { FiShield, FiUsers, FiLayers, FiUserCheck } from "react-icons/fi";
import SupportTeamPermissionsTab from "./components/support/SupportTeamPermissionsTab";
import UserPermissionsTab from "./components/user/UserPermissionsTab";
import { toast } from "react-toastify";
import Axios from "../../../_services/caller.service";
import LevelsTab from "./components/LevelsTab";
import { useTranslation } from "react-i18next";

const PermissionsManager = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState("user");

  const TABS = [
    { key: "user",        label: t("permissions.users_tab"),          icon: <FiUsers /> },
    { key: "supportTeam", label: "Support Team",                      icon: <FiUserCheck /> },
    { key: "support",     label: t("permissions.support_levels_tab"), icon: <FiShield /> },
    { key: "group",       label: t("permissions.group_levels_tab"),   icon: <FiLayers /> },
  ];

  useEffect(() => {
    const fetchPermissionsUsers = async () => {
      try {
        await Axios.get("/syncAllPermissionsUsers");
        toast.success(t("permissions.wp_synced"));
      } catch (err) {
        console.error("Erreur synchronisation WordPress :", err);
      }
    };

    fetchPermissionsUsers();
  }, []);

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h2>{t("permissions.management_title")}</h2>
      </div>

      <div className={styles.tabBar}>
        {TABS.map((tab) => (
          <button
            key={tab.key}
            onClick={() => setActiveTab(tab.key)}
            className={`${styles.tabBtn} ${activeTab === tab.key ? styles.tabActive : ""}`}
          >
            {tab.icon} {tab.label}
          </button>
        ))}
      </div>

      <div className={styles.tabContent}>
        {activeTab === "support" && <LevelsTab role="support" />}
        {activeTab === "supportTeam" && <SupportTeamPermissionsTab />}
        {activeTab === "group" && <LevelsTab role="user" />}
        {activeTab === "user" && <UserPermissionsTab />}
      </div>
    </div>
  );
};

export default PermissionsManager;
